var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReturnIcon = function SvgReturnIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.019,
    height: 9.34,
    viewBox: "0 0 13.019 9.34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8416",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8416",
    d: "M401.679-715.93v-1.145h.972a3.331,3.331,0,0,0,3.34-2.827,3.258,3.258,0,0,0-3.227-3.683.542.542,0,0,0-.542.543.543.543,0,0,0,.5.541,2.259,2.259,0,0,1,1.994,1.189,2.187,2.187,0,0,1-1.952,3.153h-1.085v-1.146a.269.269,0,0,0-.41-.229l-2.744,1.686a.268.268,0,0,0,0,.457c.664.41,2.054,1.266,2.746,1.692a.269.269,0,0,0,.41-.23m-4.34-5.424V-722.5h-.988a2.235,2.235,0,0,0-2.256,1.953,2.172,2.172,0,0,0,2.159,2.387.542.542,0,0,1,.542.543.543.543,0,0,1-.542.542,3.259,3.259,0,0,1-3.227-3.683,3.331,3.331,0,0,1,3.34-2.826h.972v-1.146a.269.269,0,0,1,.41-.229l2.744,1.685a.269.269,0,0,1,0,.458c-.664.41-2.054,1.266-2.746,1.692a.269.269,0,0,1-.41-.23",
    transform: "translate(-393 725)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturnIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/returnIcon.1f7bc2e9.svg";
export { ForwardRef as ReactComponent };